// Core
import React from 'react'

// Library
import clsx from 'clsx'

// Styles
import classes from 'components/Onboarding/StepProgress/StepProgress.module.scss'

// Interface
interface IStepProgressProps {
  step: number
  label: string
  theme?: string
  className?: string
}
export default function StepProgress({
  step,
  label,
  theme = 'pending',
  className = '',
}: IStepProgressProps) {
  return (
    <div className={clsx(
      classes.element, classes[theme], 'mt-3', 'mt-xl-up-5', classes[className]
    )}>
      <div className={clsx(classes.container)}>
        <div className={clsx(classes.number)}>
          {step}
        </div>
        <div className={clsx(classes.bar)} />
      </div>
      <div className={clsx(classes.label)}>
        {label}
      </div>
    </div>
  )
}
